var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortArrow = function SvgSortArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M1.403.47 4 3.1 6.597.47a.65.65 0 0 1 .934.005.68.68 0 0 1-.005.955L4 5 .475 1.43A.68.68 0 0 1 .47.475a.656.656 0 0 1 .933-.004z"
  })));
};
export default SvgSortArrow;